import type { CSSProperties } from 'react'

/** Deterministic petal layout - a fixed table reads the same on every load. */
const PETALS: ReadonlyArray<{
  left: string
  delay: string
  duration: string
  drift: string
  size: string
}> = [
  { left: '6%', delay: '0s', duration: '19s', drift: '7vw', size: '14px' },
  { left: '17%', delay: '4.5s', duration: '23s', drift: '-4vw', size: '10px' },
  { left: '28%', delay: '9s', duration: '17s', drift: '5vw', size: '17px' },
  { left: '39%', delay: '2s', duration: '25s', drift: '-6vw', size: '12px' },
  { left: '50%', delay: '12s', duration: '20s', drift: '8vw', size: '15px' },
  { left: '61%', delay: '6.5s', duration: '22s', drift: '-3vw', size: '11px' },
  { left: '72%', delay: '15s', duration: '18s', drift: '6vw', size: '16px' },
  { left: '83%', delay: '1s', duration: '26s', drift: '-7vw', size: '13px' },
  { left: '93%', delay: '10s', duration: '21s', drift: '4vw', size: '10px' },
]

/** Petals drifting down the background. Timing lives in animations.css. */
export function Petals() {
  return (
    <>
      {PETALS.map((petal) => (
        <span
          key={petal.left}
          className="animate-petal absolute top-0 block rounded-[50%_50%_50%_0] bg-rose-300/70"
          style={
            {
              left: petal.left,
              width: petal.size,
              height: petal.size,
              '--petal-delay': petal.delay,
              '--petal-duration': petal.duration,
              '--petal-drift-x': petal.drift,
            } as CSSProperties
          }
        />
      ))}
    </>
  )
}
